
import Vue from "vue";
import Component from "vue-class-component";
import WebplayerLayout from "./components/WebplayerLayout.vue";
import { Getter } from "vuex-class";
import { PlayerGetters } from "./store/store.getters";
import { RenderablePlaylistEntry } from "./interfaces/playlist";

@Component({
  components: {
    WebplayerLayout,
  },
})
export default class App extends Vue {
  name = "App";

  @Getter(PlayerGetters.renderablePlaylist) playlist!: RenderablePlaylistEntry[];

  get loaded() {
    return this.playlist.length > 0;
  }
}
